import React, { useCallback, useEffect, useRef, useState } from "react";

const TitleLine: React.FC<{ text: string }> = ({ text }) => {
  const [letters, setLetters] = useState(
    text.split("").map(c => ({ active: false, text: c }))
  );

  const timerRef = useRef<number>(-1);

  const randomLetters = useCallback(() => {
    timerRef.current = window.setTimeout(() => {
      setLetters(state =>
        state.map(obj => ({
          text: obj.text,
          active: Math.random() > 0.75,
        }))
      );
      randomLetters();
    }, 2000);
  }, []);

  useEffect(() => {
    randomLetters();
    return () => clearTimeout(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {letters.map((obj, idx) => (
        <span
          style={
            { "--logo-shape": obj.active ? 9000 : 0 } as React.CSSProperties
          }
          key={idx}
        >
          {obj.text}
        </span>
      ))}
    </>
  );
};

export { TitleLine };
